<template>

  <form @submit.prevent="checkCreds">
    <div class="login-sub text-center">
      <h1 class="sendi-admin-login-title" v-if="this.$route.params.id == 'admin'" >Acceso de administradores</h1>
      <h1 class="sendi-admin-login-title" v-if="this.$route.params.id == 'oper'" >Acceso de operadores</h1>
      <h1 class="sendi-admin-login-title" v-if="this.$route.params.id!== 'admin' && this.$route.params.id !== 'oper'" >Acceso de clientes</h1>
    </div>

    <div class="">

      <div class="form-group">

        <!--<label for="email" class="float-left">Nombre de Usuario</label>-->

        <input
          v-if="this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper'"
          type="email"
          :class="'form-control login__input ' + validationUser"
          id="email"
          autocomplete="username"
          placeholder="Correo electrónico" aria-label="Correo electrónico"
          v-model="Contraseña"
        >

        <input
          v-else
          type="text"
          :class="'form-control login__input ' + validationUser"
          id="email"
          autocomplete="username"
          placeholder="Tu usuario" aria-label="Usuario"
          v-model="username"
        >

        <small v-if="responseUser" class="text-danger d-flex align-items-start">{{responseUser}}</small>

      </div>

      <div class="form-group">

        <!-- <label for="password" class="d-flex justify-content-between align-items-center">
          Contraseña
        </label>-->

        <input
          type="password"
          :class="'form-control login__input ' + validationPass"
          id="password"
          placeholder="Tu contraseña" aria-label="Contraseña" autocomplete="current-password"
          v-model="password"
        >

        <small v-if="responsePass" class="text-danger d-flex align-items-start">{{responsePass}}</small>

        <router-link
        v-if="this.$route.params.id == 'admin' || this.$route.params.id == 'oper'"
        :to="'/login/'+ this.$route.params.id + '/changepassword'"
        class="registerAnchor account"
        >¿Olvidaste tu contraseña?</router-link>

      </div>

      <button
        type="submit"
        id="submit"
        :class="'btn btn-primary btn-block btn-round ' + loading"
      >Continuar</button>

      <div
        v-if="this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper'"
        class=""
      >
      </div>

      <div class="form-word">

      <!--<span class="register">Iniciar Sesión</span>-->

      <!-- <router-link
        v-if="this.$route.params.id == 'admin' || this.$route.params.id == 'oper'"
        class="account"
        :to="'/login/'+ this.$route.params.id + '/create'"
        append
      >

        <span class="text-black" >¿No tienes cuenta?</span>
        <a class="registerAnchor">Regístrate</a>

      </router-link> -->

    </div>

    </div>

    <div v-if="response">

      <p class="text-danger">{{response}}</p>

    </div>

  </form>

</template>

<script>
// import api from '../api'
import spanish from 'vee-validate/dist/locale/es'
import axios from 'axios'
// import { log } from 'util'
import { notificationService } from '@/services/notification.service'
export default {
    name: 'LoginForm',
    data(router) {
        console.log("entré acá")
        return {
            locale: 'en',
            section: 'Login',
            loading: '',
            username: '',
            password: '',
            response: '',
            validationUser: null,
            validationPass: null,
            responsePass: '',
            responseUser: ''
        }
    },
    created(){
        this.$validator.localize('es', {
            messages: spanish.messages,
            attributes: {
                foo: 'bar'
            }
        });
        this.$validator.localize('es');
    },
    methods: {
        async checkCreds() {
            // const { username, password } = this
            let self = this
            let url = ''
            let first = 'first'
            this.toggleLoading()
            this.$store.commit('TOGGLE_LOADING')
            this.resetResponse()
            if (this.validateUser(first, this.$route.params.id)) {
                console.log("Validated first step");
                this.resetResponse();
                let data = new Object();
                data.username = this.username;
                data.password = this.password;
                switch(this.$route.params.id){
                    case 'admin':
                        url = process.env.API_URL + '/api/admin/login-admin';
                        break;
                    case 'oper':
                        url = process.env.API_URL + '/api/operator/login-operator';
                        break;
                    case 'client':
                        url = process.env.API_URL + '/client/login-client';
                        break;
                    default:
                        console.log("default on checkCreds");
                        break;
                }
                let res = await axios.post(url, data).then(response => {
                    this.toggleLoading()
                    console.log('success')
                    console.log(response.data)
                    if (response.data.status) {
                        // var token = 'Bearer ' + data.token

                        this.$store.commit('SET_USER', response.data.body)
                        this.$store.commit('SET_TOKEN', 'some token')

                        console.log(response.data.body)


                        if (window.localStorage) {
                            window.localStorage.setItem( 'user', JSON.stringify(response.data.body) )
                            window.localStorage.setItem('token', 'some token2')
                        }
                        console.log(window.localStorage.getItem('token'))
                        console.log(window.localStorage.getItem('user'))
                        return true

                    }
                }).catch(error => {
                    if (error.response) {
                        let responseMessage
                        let errorFlag
                        if (error.response.status === 400) {
                            self.response = 'Error 400'
                        } else if (error.response.status === 404) {
                            self.response = 'Error 404'
                        } else if ( error.response.status === 422 || error.response.status === 401 ) {
                            console.log('entro')
                            /* self.response = 'Errores de validación, por favor, vuelve a intentarlo' */
                            if (error.response.data.errors.hasOwnProperty('username')) {
                                console.log("Este if");
                                if (error.response.data.errors.username[0].slice(0, 1).toString() === '1') {
                                    let userInc = 'userInc';
                                    console.log("This one");
                                    self.validateUser(userInc)
                                }
                            } else if (error.response.data.errors.hasOwnProperty('email')) {
                                console.log("segudno if");
                                responseMessage = error.response.data.errors.email[0]
                                console.log(responseMessage)
                                errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')))
                                if (errorFlag === 1) {
                                    console.log("This other one");
                                    self.validateUser('userInc')
                                }
                            } else if ( error.response.data.errors.hasOwnProperty('password')) {
                                console.log("tercer if");
                                responseMessage = error.response.data.errors.password[0]
                                console.log(responseMessage)
                                errorFlag = parseInt(responseMessage.substr(0, responseMessage.indexOf('.')))
                                switch(errorFlag){
                                    case 1:
                                        console.log("errorFlag value: ".concat(1));
                                        self.validateUser('passInc');
                                        break;
                                    case 2:
                                        console.log("errorFlag value: ".concat(2));
                                        self.validateUser('invalid_password');
                                        break;
                                    default:
                                        console.log("Default case in switch");
                                        break;
                                }
                            }
                        } else if (error.response.status === 500) {
                            self.response = 'Error de servidor. Inténtelo más tarde.';
                        } else {
                            self.response = 'Error inesperado';
                        }
                        /* console.log(error.response.data)
                            console.log(error.response.status)
                            console.log(error.response.headers) */
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log('Error', error.message)
                    }
                    console.log(error.config)
                    return false
                });

                console.log("RES");
                console.log( res);


                console.log("**********");



                if (res){
                    await notificationService.getCurrentNotifications(this.$store.state.user.attributes.profile.id, this.logingSuccess)




                }

            }
            this.validation = null;

        },

        logingSuccess(notificationData){
            console.log("logginSuccess");

            this.$store.commit('SET_NOTIFICATIONS', notificationData)
            this.$router.push('/')
        },
        toggleLoading() {
        this.loading = this.loading === '' ? 'loading' : ''
        },
        resetResponse() {
        this.response = ''
        this.responsePass = ''
        this.responseUser = ''
        this.validationUser = null
        this.validationPass = null
        },
        validateUser(atr, role = '') {
            console.log(role)
            switch(atr){
                case 'first': //this should be changed for a number
                    let usernameLengthValidationFlag = false;
                    let passwordLengthValidationFlag = false;
                    let usernameResponseMessage = '';
                    if (role === 'admin' || role === 'oper') {
                        usernameLengthValidationFlag = this.username.length < 3 || this.username.length > 20;
                        usernameResponseMessage = 'El username debe tener entre 3 y 20 caracteres';
                    } else {
                        usernameLengthValidationFlag = this.username.length < 5 || this.username.length > 100;
                        usernameResponseMessage = 'El username debe tener entre 5 y 100 caracteres';
                    }
                    this.validationUser = usernameLengthValidationFlag ? 'incorrect' : 'correct';
                    this.responseUser = usernameLengthValidationFlag ? usernameResponseMessage : '';

                    passwordLengthValidationFlag = this.password.length < 8 || this.password.length > 20;

                    this.validationPass = passwordLengthValidationFlag ? 'incorrect' : 'correct';
                    this.responsePass = passwordLengthValidationFlag ? 'La contraseña debe tener entre 8 y 20 caracteres' : '';
                    console.log( !usernameLengthValidationFlag && !passwordLengthValidationFlag );
                    return !usernameLengthValidationFlag && !passwordLengthValidationFlag;
                    break;
                case 'userInc':
                    this.validationUser = 'incorrect';
                    this.responseUser = 'Usuario no existe';
                    break;
                case 'passInc':
                    this.validationPass = 'incorrect';
                    this.responsePass = 'Contraseña incorrecta';
                    break;
                case 'invalid_password':
                    this.validationPass = 'incorrect';
                    this.responsePass = 'Contraseña incorrecta';
                    break;
                default:
                    console.log("Default case for atr in function validateUser");
                    break;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// LoginForm.vue?38b3b6e2